// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operations.screen {
  width: 100%;
  max-width: 1180px;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}

.operations__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 30px);
}

.ops__meta {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin: 2px 0 20px;
  color: var(--palette-text-muted);
  font-size: 0.78rem;
}

.ops__metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.ops__metric,
.ops__filters,
.ops__breakdown,
.ops__chart,
.ops__state {
  border: 1px solid var(--palette-border);
  border-radius: 14px;
  background: var(--palette-surface);
}

.ops__filters {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 18px;
  padding: 18px 20px;
}

.ops__filters h2,
.ops__section-heading h2 {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.25rem;
}

.ops__filters p,
.ops__section-heading p {
  margin: 5px 0 0;
  color: var(--palette-text-muted);
  font-size: 0.78rem;
  line-height: 1.4;
}

.ops__filter-fields {
  display: flex;
  flex: 0 0 auto;
  gap: 12px;
}

.ops__filter-fields label {
  display: grid;
  gap: 6px;
  color: var(--palette-text-muted);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ops__filter-fields select {
  min-width: 150px;
  min-height: 44px;
  padding: 0 36px 0 12px;
  border: 1px solid var(--palette-border-strong);
  border-radius: 8px;
  background: var(--palette-bg);
  color: var(--palette-text);
  font: inherit;
  font-size: 0.86rem;
  font-weight: 600;
  letter-spacing: normal;
  text-transform: none;
}

.ops__filter-fields select:focus-visible {
  outline: 3px solid color-mix(in srgb, var(--palette-secondary) 45%, transparent);
  outline-offset: 2px;
}

.ops__metric {
  padding: 18px;
}

.ops__metric h2 {
  margin: 0 0 10px;
  color: var(--palette-text-muted);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ops__metric strong {
  display: block;
  color: var(--palette-primary);
  font-family: var(--font-display);
  font-size: 2rem;
  line-height: 1;
}

.ops__metric p {
  margin: 9px 0 0;
  color: var(--palette-text-muted);
  font-size: 0.78rem;
  line-height: 1.35;
}

.ops__chart {
  margin-top: 18px;
  padding: 20px;
}

.ops__breakdown {
  margin-top: 18px;
  padding: 20px;
}

.ops__section-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
}

.ops__section-heading p {
  margin: 0;
  text-align: right;
}

.ops__table-wrap {
  margin-top: 14px;
  overflow-x: auto;
  border-radius: 8px;
}

.ops__table-wrap:focus-visible {
  outline: 3px solid color-mix(in srgb, var(--palette-secondary) 45%, transparent);
  outline-offset: 3px;
}

.ops__table-wrap table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
}

.ops__table-wrap th,
.ops__table-wrap td {
  padding: 11px 12px;
  border-bottom: 1px solid var(--palette-border);
  text-align: left;
}

.ops__table-wrap thead th {
  color: var(--palette-text-muted);
  font-size: 0.7rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.ops__table-wrap tbody th,
.ops__table-wrap tbody td {
  font-size: 0.86rem;
}

.ops__table-wrap tbody th {
  font-weight: 700;
}

.ops__table-wrap th:nth-child(n + 4),
.ops__table-wrap td:nth-child(n + 4) {
  text-align: right;
}

.ops__table-wrap tbody tr:last-child th,
.ops__table-wrap tbody tr:last-child td {
  border-bottom: 0;
}

.opschart__hint {
  min-height: 1.4em;
  margin: 8px 0 4px;
  color: var(--palette-text-muted);
  font-size: 0.8rem;
}

.opschart__sr {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.opschart svg {
  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
  touch-action: none;
  border-radius: 8px;
}

.opschart svg:focus-visible {
  outline: 3px solid color-mix(in srgb, var(--palette-secondary) 45%, transparent);
  outline-offset: 3px;
}

.opschart text {
  fill: var(--palette-text-muted);
  font-size: 12px;
}

.opschart__axis {
  stroke: var(--palette-border-strong);
  stroke-width: 1;
}

.opschart__line {
  fill: none;
  stroke: var(--palette-secondary);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.opschart__crosshair {
  stroke: var(--palette-primary);
  stroke-width: 2;
  stroke-dasharray: 5 5;
}

.opschart__point {
  fill: var(--palette-surface);
  stroke: var(--palette-primary);
  stroke-width: 4;
}

.opschart__callout rect {
  fill: var(--palette-text);
  stroke: var(--palette-surface);
  stroke-width: 2;
}

.opschart__callout text {
  fill: var(--palette-bg);
  font-size: 13px;
  font-weight: 600;
}

.opschart__callout .opschart__callout-value {
  fill: var(--palette-bg);
  font-size: 15px;
  font-weight: 800;
}

.ops__empty,
.ops__note {
  color: var(--palette-text-muted);
  font-size: 0.78rem;
}

.ops__empty {
  padding: 60px 0;
  text-align: center;
}

.ops__empty--compact {
  padding: 24px 0 8px;
}

.ops__note {
  margin: 14px 2px 0;
}

.ops__state {
  padding: 34px 24px;
  text-align: center;
}

.ops__state h2 {
  margin: 0 0 8px;
  font-family: var(--font-display);
}

.ops__state p {
  margin: 0;
  color: var(--palette-text-muted);
}

.ops__state .btn {
  width: auto;
  margin-top: 18px;
}

@media (max-width: 760px) {
  .ops__filters {
    display: grid;
    align-items: stretch;
  }

  .ops__filter-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ops__filter-fields select {
    width: 100%;
    min-width: 0;
  }

  .ops__metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .ops__meta {
    display: grid;
    gap: 4px;
  }

  .ops__metrics {
    grid-template-columns: 1fr;
  }

  .ops__section-heading {
    display: grid;
    gap: 2px;
  }

  .ops__section-heading p {
    text-align: left;
  }

  .ops__breakdown,
  .ops__chart {
    padding: 14px 10px;
  }

  .opschart svg {
    min-height: 230px;
  }
}

@media (max-width: 360px) {
  .ops__filter-fields {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/operationsScreen.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;;;;EAKE,uCAAuC;EACvC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;EAC9C,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gFAAgF;EAChF,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gFAAgF;EAChF,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gFAAgF;EAChF,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,gDAAgD;EAClD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".operations.screen {\n  width: 100%;\n  max-width: 1180px;\n  height: 100vh;\n  height: 100dvh;\n  overflow: hidden;\n}\n\n.operations__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 30px);\n}\n\n.ops__meta {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 2px 0 20px;\n  color: var(--palette-text-muted);\n  font-size: 0.78rem;\n}\n\n.ops__metrics {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.ops__metric,\n.ops__filters,\n.ops__breakdown,\n.ops__chart,\n.ops__state {\n  border: 1px solid var(--palette-border);\n  border-radius: 14px;\n  background: var(--palette-surface);\n}\n\n.ops__filters {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 18px;\n  padding: 18px 20px;\n}\n\n.ops__filters h2,\n.ops__section-heading h2 {\n  margin: 0;\n  font-family: var(--font-display);\n  font-size: 1.25rem;\n}\n\n.ops__filters p,\n.ops__section-heading p {\n  margin: 5px 0 0;\n  color: var(--palette-text-muted);\n  font-size: 0.78rem;\n  line-height: 1.4;\n}\n\n.ops__filter-fields {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 12px;\n}\n\n.ops__filter-fields label {\n  display: grid;\n  gap: 6px;\n  color: var(--palette-text-muted);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.ops__filter-fields select {\n  min-width: 150px;\n  min-height: 44px;\n  padding: 0 36px 0 12px;\n  border: 1px solid var(--palette-border-strong);\n  border-radius: 8px;\n  background: var(--palette-bg);\n  color: var(--palette-text);\n  font: inherit;\n  font-size: 0.86rem;\n  font-weight: 600;\n  letter-spacing: normal;\n  text-transform: none;\n}\n\n.ops__filter-fields select:focus-visible {\n  outline: 3px solid color-mix(in srgb, var(--palette-secondary) 45%, transparent);\n  outline-offset: 2px;\n}\n\n.ops__metric {\n  padding: 18px;\n}\n\n.ops__metric h2 {\n  margin: 0 0 10px;\n  color: var(--palette-text-muted);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.ops__metric strong {\n  display: block;\n  color: var(--palette-primary);\n  font-family: var(--font-display);\n  font-size: 2rem;\n  line-height: 1;\n}\n\n.ops__metric p {\n  margin: 9px 0 0;\n  color: var(--palette-text-muted);\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.ops__chart {\n  margin-top: 18px;\n  padding: 20px;\n}\n\n.ops__breakdown {\n  margin-top: 18px;\n  padding: 20px;\n}\n\n.ops__section-heading {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.ops__section-heading p {\n  margin: 0;\n  text-align: right;\n}\n\n.ops__table-wrap {\n  margin-top: 14px;\n  overflow-x: auto;\n  border-radius: 8px;\n}\n\n.ops__table-wrap:focus-visible {\n  outline: 3px solid color-mix(in srgb, var(--palette-secondary) 45%, transparent);\n  outline-offset: 3px;\n}\n\n.ops__table-wrap table {\n  width: 100%;\n  min-width: 640px;\n  border-collapse: collapse;\n}\n\n.ops__table-wrap th,\n.ops__table-wrap td {\n  padding: 11px 12px;\n  border-bottom: 1px solid var(--palette-border);\n  text-align: left;\n}\n\n.ops__table-wrap thead th {\n  color: var(--palette-text-muted);\n  font-size: 0.7rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.ops__table-wrap tbody th,\n.ops__table-wrap tbody td {\n  font-size: 0.86rem;\n}\n\n.ops__table-wrap tbody th {\n  font-weight: 700;\n}\n\n.ops__table-wrap th:nth-child(n + 4),\n.ops__table-wrap td:nth-child(n + 4) {\n  text-align: right;\n}\n\n.ops__table-wrap tbody tr:last-child th,\n.ops__table-wrap tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.opschart__hint {\n  min-height: 1.4em;\n  margin: 8px 0 4px;\n  color: var(--palette-text-muted);\n  font-size: 0.8rem;\n}\n\n.opschart__sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.opschart svg {\n  display: block;\n  width: 100%;\n  height: auto;\n  overflow: visible;\n  touch-action: none;\n  border-radius: 8px;\n}\n\n.opschart svg:focus-visible {\n  outline: 3px solid color-mix(in srgb, var(--palette-secondary) 45%, transparent);\n  outline-offset: 3px;\n}\n\n.opschart text {\n  fill: var(--palette-text-muted);\n  font-size: 12px;\n}\n\n.opschart__axis {\n  stroke: var(--palette-border-strong);\n  stroke-width: 1;\n}\n\n.opschart__line {\n  fill: none;\n  stroke: var(--palette-secondary);\n  stroke-width: 3;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.opschart__crosshair {\n  stroke: var(--palette-primary);\n  stroke-width: 2;\n  stroke-dasharray: 5 5;\n}\n\n.opschart__point {\n  fill: var(--palette-surface);\n  stroke: var(--palette-primary);\n  stroke-width: 4;\n}\n\n.opschart__callout rect {\n  fill: var(--palette-text);\n  stroke: var(--palette-surface);\n  stroke-width: 2;\n}\n\n.opschart__callout text {\n  fill: var(--palette-bg);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.opschart__callout .opschart__callout-value {\n  fill: var(--palette-bg);\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.ops__empty,\n.ops__note {\n  color: var(--palette-text-muted);\n  font-size: 0.78rem;\n}\n\n.ops__empty {\n  padding: 60px 0;\n  text-align: center;\n}\n\n.ops__empty--compact {\n  padding: 24px 0 8px;\n}\n\n.ops__note {\n  margin: 14px 2px 0;\n}\n\n.ops__state {\n  padding: 34px 24px;\n  text-align: center;\n}\n\n.ops__state h2 {\n  margin: 0 0 8px;\n  font-family: var(--font-display);\n}\n\n.ops__state p {\n  margin: 0;\n  color: var(--palette-text-muted);\n}\n\n.ops__state .btn {\n  width: auto;\n  margin-top: 18px;\n}\n\n@media (max-width: 760px) {\n  .ops__filters {\n    display: grid;\n    align-items: stretch;\n  }\n\n  .ops__filter-fields {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .ops__filter-fields select {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .ops__metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 480px) {\n  .ops__meta {\n    display: grid;\n    gap: 4px;\n  }\n\n  .ops__metrics {\n    grid-template-columns: 1fr;\n  }\n\n  .ops__section-heading {\n    display: grid;\n    gap: 2px;\n  }\n\n  .ops__section-heading p {\n    text-align: left;\n  }\n\n  .ops__breakdown,\n  .ops__chart {\n    padding: 14px 10px;\n  }\n\n  .opschart svg {\n    min-height: 230px;\n  }\n}\n\n@media (max-width: 360px) {\n  .ops__filter-fields {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
